const types = {
    ERROR: 0,
    CHECKING: 1,
    STARTED: 2,
    FINISHED: 3,
    SUCCESS: 4,
};

const methods = {
    isError: (type) => type === types.ERROR,
    isChecking: (type) => type === types.CHECKING,
    isFinished: (type) => type === types.FINISHED,
    isStarted: (type) => type === types.STARTED,
    isSuccess: (type) => type === types.SUCCESS,
};

export default {
    ...types,
    ...methods,
};
